var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6119",
    "data-name": "Group 6119",
    transform: "translate(1682 -2122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2477",
    "data-name": "Rectangle 2477",
    width: 8,
    height: 10,
    transform: "translate(-1682 2122)",
    fill: "#8fadce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2480",
    "data-name": "Rectangle 2480",
    width: 8,
    height: 10,
    transform: "translate(-1672 2131)",
    fill: "#8fadce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2478",
    "data-name": "Rectangle 2478",
    width: 8,
    height: 7,
    transform: "translate(-1672 2122)",
    fill: "#8fadce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2479",
    "data-name": "Rectangle 2479",
    width: 8,
    height: 7,
    transform: "translate(-1682 2134)",
    fill: "#8fadce"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.729cd70e4d19fa5e1ee1065ad560be4c.svg";
export { ForwardRef as ReactComponent };